import apiUrls from '../urls'

export default function (api) {
	return {
		sendPoints(data) {
			return api.post(apiUrls.USER_IDENTITIES, data, {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
				},
			})
		},
	}
}
